import { type ToastItem, useToastStore } from "~/stores/ui/toaststore";

export default defineNuxtRouteMiddleware((_unused_to) => {
  console.debug("userIsLoggedIn middleware");
  const userStore = useUserStore();
  console.debug(userStore.authUserUuid);
  if (!userStore.authUserUuid) {
    console.error(`User is not logged in.`);
    const toastStore = useToastStore();
    toastStore.addToast({
      id: self.crypto.randomUUID(),
      title: `Redirecting`,
      body: `Login required`,
      appendToast: false,
      position: "top-center",
      variant: "warning",
      solid: true,
    } as ToastItem);
    return navigateTo("/");
  }
});
